import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { APIRequestStatus } from "common-ts/dist/models/APIRequestStatus";
import WorkBatchCut from "common-ts/dist/models/WorkBatchCut";

interface WorkBatchCutListState {
    workBatchCutList: WorkBatchCut[],
  
    status: APIRequestStatus,
    error: string | null,
}

const initialState : WorkBatchCutListState = {
    workBatchCutList: [],

    status: APIRequestStatus.Idle,
    error: null
}

export const fetchWorkBatchCutList = createAsyncThunk('workBatchCutList/fetchWorkBatchCutList', async () => {
    const response = await axios({
        method: 'get',
        url: 'https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/work-batch-cut',
    });
    return response.data
})

export const workBatchCutSlice = createSlice({
    name: 'workBatchCutList',
    initialState,
    reducers: {
    },
    extraReducers(builder) {
      builder
        .addCase(fetchWorkBatchCutList.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
        })
        .addCase(fetchWorkBatchCutList.fulfilled, (state, action) => {
            state.workBatchCutList = action.payload.recordList;

            state.status = APIRequestStatus.Success;
        })
        .addCase(fetchWorkBatchCutList.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            // state.error = action.error.message
            console.log("fetch is failure");
        })
    }
})

export default workBatchCutSlice.reducer